import { Button, Table, PageHeader, Modal, Col, Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Controller, useForm } from "react-hook-form";
import FormLayout, { FormItem } from "Components/form";
import DatePicker from "Components/date-picker-localized";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { createComponentStore, useStoreState } from "easy-peasy";
import { clean, sort } from "Utils";

import {
  LODGING_PAYMENT_TYPE,
  RENTABLE_AREA_POSITIONS,
  ALLOCATION_TYPES,
  LODGING_PLACE,
} from "Constants";

import {
  LodgementReportStoreModel,
  ACTION_TYPES,
} from "store/models/reports/lodgement";
import ExportExcel from "Components/export-excel";
import FetchSelect from "Components/fetch-select";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import FourOThree from "Pages/private/403";

const useLodgementReportsStore = createComponentStore(
  LodgementReportStoreModel
);

export default function LodgementReportPage() {
  const { abilities } = useStoreState((store) => store.auth);
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.READ,
    "Lojman Raporları"
  );

  const [store, actions] = useLodgementReportsStore();
  const { fetch, search, setFilters } = actions;
  const { process, data, filters } = store;
  const [filterModalVisible, setFilterModalVisible] = useState(false);

  useEffect(() => {
    fetch(filters);
  }, [filters]);

  const form = useForm({
    mode: "onSubmit",
    defaultValues: {
      taskdistilecodes: null,
      positions: null,
      dateOfPeriod: null,
    },
  });

  const { handleSubmit, reset } = form;

  const handleAdvancedSearchOK = (form) => {
    let filterData = { ...form };

    delete filterData.dateOfPeriod;
    if (form.dateOfPeriod) {
      filterData.year = form.dateOfPeriod.year();
      filterData.month = form.dateOfPeriod.month() + 1;
    }

    delete filterData.taskdistilecodes;
    if (form.taskdistilecodes) {
      filterData.taskdistilecodes = form.taskdistilecodes.code;
    }

    clean(filterData);
    setFilters(filterData);
    setFilterModalVisible(false);
  };

  const handleAdvancedSearchCancel = () => {
    reset();
    setFilters({});
  };

  const columns = [
    {
      title: "İsim",
      dataIndex: "name",
      key: "name",
      width: 170,
      ellipsis: true,
      sorter: (a, b) =>
        sort(
          (a.name || "") + " " + (a.surname || ""),
          (b.name || "") + " " + (b.surname || "")
        ),
      render: (text, record) =>
        (record.name || "") + " " + (record.surname || ""),
    },

    {
      title: "Kimlik No",
      dataIndex: "identityNumber",
      key: "identityNumber",
      width: 130,
      ellipsis: true,
      sorter: (a, b) => sort(a.identityNumber, b.identityNumber),
    },

    {
      title: "Telefon",
      dataIndex: "phone",
      key: "phone",
      width: 130,
      ellipsis: true,
      sorter: (a, b) => sort(a.phone, b.phone),
    },

    {
      title: "Görev Ayrım Unvanı",
      dataIndex: "taskDistTitleDesc",
      key: "taskDistTitleDesc",
      width: 150,
      ellipsis: true,
      sorter: (a, b) => sort(a.taskDistTitleDesc, b.taskDistTitleDesc),
    },

    {
      title: "Dönem",
      dataIndex: "year",
      key: "year",
      width: 90,
      ellipsis: true,
      sorter: (a, b) =>
        sort(
          a.year + a.month.toString().padStart(2, "0"),
          b.year + b.month.toString().padStart(2, "0")
        ),
      render: (text, record) =>
        (record.month || "-") + "/" + (record.year || "-"),
    },

    {
      title: "Bölge",
      dataIndex: "unitPlace",
      key: "unitPlace",
      width: 120,
      ellipsis: true,
      sorter: (a, b) =>
        sort(LODGING_PLACE[a.unitPlace], LODGING_PLACE[b.unitPlace]),
      render: (text, record) => LODGING_PLACE[record.unitPlace] || "",
    },

    /*     {
      title: "Sözleşme Kodu",
      dataIndex: "ccode",
      key: "ccode",
    },

    {
      title: "Taşınmaz Kodu",
      dataIndex: "rcode",
      key: "rcode",
    },

    {
      title: "Birim Kodu",
      dataIndex: "ucode",
      key: "ucode",
    },

    {
      title: "Alt Birim Kodu",
      dataIndex: "scode",
      key: "scode",
    },

    {
      title: "Tapu Kodu",
      dataIndex: "dcode",
      key: "dcode",
    },
 */
    {
      title: "Durum",
      dataIndex: "position",
      key: "position",
      width: 80,
      ellipsis: true,
      sorter: (a, b) =>
        sort(
          RENTABLE_AREA_POSITIONS[a.position],
          RENTABLE_AREA_POSITIONS[b.position]
        ),
      render: (text, record) => RENTABLE_AREA_POSITIONS[record.position],
    },
    {
      title: "Tahsis Türü",
      dataIndex: "allocationType",
      key: "allocationType",
      width: 80,
      ellipsis: true,
      sorter: (a, b) =>
        sort(
          ALLOCATION_TYPES[a.allocationType],
          ALLOCATION_TYPES[b.allocationType]
        ),
      render: (text, record) => ALLOCATION_TYPES[record.allocationType] || "",
    },

    {
      title: "Kira Ödeme Bilgisi",
      dataIndex: "lodgingRent",
      key: "lodgingRent",
      width: 130,
      ellipsis: true,
      sorter: (a, b) =>
        sort(
          LODGING_PAYMENT_TYPE[a.lodgingRent],
          LODGING_PAYMENT_TYPE[b.lodgingRent]
        ),
      render: (text, record) => LODGING_PAYMENT_TYPE[record.lodgingRent] || "",
    },

    /*     {
      title: "Kiralanmış Alan Kodu",
      dataIndex: "reCode",
      key: "reCode",
    }, */

    {
      title: "Ölçüm değeri",
      dataIndex: "measureValue",
      key: "measureValue",
      width: 100,
      ellipsis: true,
      sorter: (a, b) => sort(a.measureValue, b.measureValue),
    },

    {
      title: "İl",
      dataIndex: "province",
      key: "province",
      width: 110,
      ellipsis: true,
      sorter: (a, b) => sort(a.province, b.province),
    },

    {
      title: "İlçe",
      dataIndex: "district",
      key: "district",
      width: 110,
      ellipsis: true,
      sorter: (a, b) => sort(a.district, b.district),
    },

    {
      title: "Mahalle",
      dataIndex: "neighborhood",
      key: "neighborhood",
      width: 110,
      ellipsis: true,
      sorter: (a, b) => sort(a.neighborhood, b.neighborhood),
    },

    {
      title: "Ada No",
      dataIndex: "islandNumber",
      key: "islandNumber",
      width: 90,
      ellipsis: true,
      sorter: (a, b) => sort(a.islandNumber, b.islandNumber),
    },

    {
      title: "Sıra No",
      dataIndex: "orderNumber",
      key: "orderNumber",
      width: 90,
      ellipsis: true,
      sorter: (a, b) => sort(a.orderNumber, b.orderNumber),
    },

    {
      title: "Parsel No",
      dataIndex: "parcelNumber",
      key: "parcelNumber",
      width: 90,
      ellipsis: true,
      sorter: (a, b) => sort(a.parcelNumber, b.parcelNumber),
    },

    {
      title: "Pafta No",
      dataIndex: "sheetNumber",
      key: "sheetNumber",
      width: 90,
      ellipsis: true,
      sorter: (a, b) => sort(a.sheetNumber, b.sheetNumber),
    },

    {
      title: "Blok",
      dataIndex: "blockNo",
      key: "blockNo",
      width: 90,
      ellipsis: true,
      sorter: (a, b) => sort(a.blockNo, b.blockNo),
    },

    {
      title: "Kat",
      dataIndex: "floor",
      key: "floor",
      width: 90,
      ellipsis: true,
      sorter: (a, b) => sort(a.floor, b.floor),
    },

    {
      title: "Daire",
      dataIndex: "flat",
      key: "flat",
      width: 90,
      ellipsis: true,
      sorter: (a, b) => sort(a.flat, b.flat),
    },

    {
      title: "Başlangıç Tarihi",
      dataIndex: "dateOfBeginning",
      key: "dateOfBeginning",
      width: 110,
      ellipsis: true,
      sorter: (a, b) => sort(a.dateOfBeginning, b.dateOfBeginning),
      render: (text, record) => {
        return moment(record.dateOfBeginning).format("DD.MM.YYYY ");
      },
    },

    {
      title: "Bitiş Tarihi",
      dataIndex: "dateOfFinish",
      key: "dateOfFinish",
      width: 110,
      ellipsis: true,
      sorter: (a, b) => sort(a.dateOfFinish, b.dateOfFinish),
      render: (text, record) => {
        return moment(record.dateOfFinish).format("DD.MM.YYYY ");
      },
    },
  ];

  const getExcelColumns = () => {
    return columns.map((d) => d.title);
  };

  const getExcelRows = () => {
    let rows = [];
    store.data.forEach((d) => {
      let i = [];
      i.push((d.name || "-") + " " + (d.surname || "-"));
      i.push(d.identityNumber || "-");
      i.push(d.phone || "-");
      i.push(d.taskDistTitleDesc || "-");
      i.push((d.month || "-") + "/" + (d.year || "-"));
      i.push(LODGING_PLACE[d.unitPlace] || "-");
      i.push(RENTABLE_AREA_POSITIONS[d.position] || "-");
      i.push(ALLOCATION_TYPES[d.allocationType] || "-");
      i.push(LODGING_PAYMENT_TYPE[d.lodgingRent] || "-");
      i.push(d.measureValue || "-");
      i.push(d.province || "-");
      i.push(d.district || "-");
      i.push(d.neighborhood || "-");
      i.push(d.islandNumber || "-");
      i.push(d.orderNumber || "-");
      i.push(d.parcelNumber || "-");
      i.push(d.sheetNumber || "-");
      i.push(d.blockNo || "-");
      i.push(d.floor || "-");
      i.push(d.flat || "-");
      i.push(moment(d.dateOfBeginning).format("DD.MM.YYYY") || "-");
      i.push(moment(d.dateOfFinish).format("DD.MM.YYYY") || "-");
      rows.push(i);
    });

    return rows;
  };

  return IsAuthorized ? (
    <>
      <PageHeader
        title="Lojman Raporları"
        extra={[
          <Button
            key="filter"
            onClick={() => {
              setFilterModalVisible(true);
            }}
          >
            <FontAwesomeIcon
              icon={["fas", "filter"]}
              style={{ marginRight: 8 }}
            />
            Detaylı Arama
          </Button>,

          <ExportExcel
            columnsData={getExcelColumns()}
            key={data}
            disabled={data.length < 1}
            rowsData={getExcelRows()}
            loading={store.process === ACTION_TYPES.FETCHING_DATA}
            filename={
              "Lojman Raporları_" + moment(new Date()).format("DD-MM-YYYY")
            }
          />,
        ]}
      />
      <Table
        style={{ margin: "0 24px" }}
        rowKey={(row) => row.id}
        loading={process === ACTION_TYPES.FETCHING_DATA}
        dataSource={data}
        columns={columns}
        size="small"
        bordered
        showSorterTooltip={false}
        scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
        pagination={{
          pageSize: 20,
          total: data.length,
          showSizeChanger: false,
          showTotal: (total, range) => {
            return `Toplam ${total} sonuçtan ${range.join(
              "-"
            )} arası gösteriliyor.`;
          },
        }}
      />
      <Modal
        title="Detaylı Arama"
        centered
        maskClosable={false}
        visible={filterModalVisible}
        onOk={handleSubmit(handleAdvancedSearchOK)}
        onCancel={() => setFilterModalVisible(false)}
        footer={[
          <Button key="clear" onClick={handleAdvancedSearchCancel}>
            Temizle
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleSubmit(handleAdvancedSearchOK)}
          >
            <FontAwesomeIcon
              icon={["fas", "search"]}
              style={{ marginRight: 8 }}
            />
            Ara
          </Button>,
        ]}
        width="60vw"
      >
        <FormLayout>
          <Col xs={24} md={12}>
            <FormItem label="Durum">
              <Controller
                control={form.control}
                name="positions"
                placeholder="Durum seçiniz"
                as={
                  <Select>
                    {Object.entries(RENTABLE_AREA_POSITIONS).map(
                      ([key, value]) => (
                        <Select.Option key={key} value={key}>
                          {value}
                        </Select.Option>
                      )
                    )}
                  </Select>
                }
              />
            </FormItem>
          </Col>

          <Col xs={24} md={12}>
            <FormItem htmlFor="taskDistinctionTitle" label="Görev Ayrım Unvanı">
              <FetchSelect
                api="/masterdata/taskdistinctiontitles"
                form={form}
                field="taskdistilecodes"
                placeholder="Görev ayrım unvanı seçiniz"
              />
            </FormItem>
          </Col>

          <Col xs={24}>
            <FormItem label="Dönem">
              <Controller
                name="dateOfPeriod"
                control={form.control}
                as={
                  <DatePicker
                    picker="month"
                    placeholder="Görüntülemek istediğiniz rapor dönemini seçiniz."
                    style={{ width: "100%" }}
                  />
                }
              />
            </FormItem>
          </Col>
        </FormLayout>
      </Modal>
    </>
  ) : (
    <FourOThree />
  );
}
